var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.686,
    height: 9.074,
    viewBox: "0 0 24.686 9.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38331",
    "data-name": "Group 38331",
    transform: "translate(0 1.115)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 23.683,
    transform: "translate(0 6.459)",
    fill: "none",
    stroke: "#a9bf6e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x2: 7.177,
    y2: 6.459,
    transform: "translate(16.506 0)",
    fill: "none",
    stroke: "#a9bf6e",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesArrow);
export default __webpack_public_path__ + "static/media/notesArrow.1764e7edc1459c5d487c7a0321ac11e0.svg";
export { ForwardRef as ReactComponent };